import { makeStyles } from 'tss-react/mui'
import { Typography } from '@mui/material'
import React, { ReactNode } from 'react'
import clsx from 'clsx'

const useLayoutStyles = makeStyles<{
  paddingZero?: boolean
  bgColor?: string
}>()((theme, { bgColor, paddingZero }) => ({
  root: {
    backgroundColor: theme.palette.textBackground.light,
    marginLeft: theme.spacing(9),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    height: '100vh',
    backgroundColor: bgColor ? bgColor : theme.palette.textBackground.light,
  },
  appBody: {
    width: '100%',
    padding: paddingZero ? theme.spacing(0) : theme.spacing(4, 4, 0, 4),
    boxSizing: 'border-box',
  },
}))

const useHeaderStyles = makeStyles()(theme => ({
  appTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'auto',
  },
  appTitleHeadingText: {
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '32px',
    color: theme.palette.labraText.primary,
  },
  stickyContainer: {
    position: 'sticky',
    top: 0,
    zIndex: 99,
  },
  action: {
    display: 'flex',
    justifyContent: 'row',
    paddingTop: theme.spacing(1.125),
    alignItems: 'center',
    gap: theme.spacing(4),
    height: theme.spacing(4),
    boxSizing: 'border-box',
  },
  headerContainer: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    gap: theme.spacing(4),
    padding: theme.spacing(2, 5),
    backgroundColor: theme.palette.text.white,
    boxShadow: `0px -1px 0px 0px ${theme.palette.labraV2BoxShadow.dark} inset`,
    zIndex: 105,
  },
}))

interface CloudAccountLayoutProps {
  title?: string | ReactNode
  actions?: React.FC
  component?: React.FC
  paddingZero?: boolean
  bgColor?: string
}

export const CloudAccountLayout: React.FC<CloudAccountLayoutProps> = ({
  title,
  actions: Actions,
  component: Component,
  paddingZero,
  bgColor,
}) => {
  const { classes } = useLayoutStyles({ paddingZero, bgColor })
  const { classes: headerClasses } = useHeaderStyles()

  return (
    <div className={classes.root}>
      <div className={clsx(classes.content)} id="content-id">
        {title && (
          <div
            className={clsx(
              headerClasses.headerContainer,
              headerClasses.stickyContainer
            )}
          >
            <div className={headerClasses.appTitle}>
              <div>
                <Typography
                  variant="h1"
                  data-testid="heading"
                  className={headerClasses.appTitleHeadingText}
                >
                  {title}
                </Typography>
              </div>
              <div data-testid="actions" className={headerClasses.action}>
                {Actions ? <Actions /> : null}
              </div>
            </div>
          </div>
        )}
        <div data-testid="app-body" className={classes.appBody}>
          {Component ? <Component /> : null}
        </div>
      </div>
    </div>
  )
}
